// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".client_logo[data-v-e0480c70] {\n  width: 50px;\n  display: block;\n}\n", ""]);
// Exports
module.exports = exports;
